import { useContext } from "react";
import { CreateActionContext } from "./CreateActionContext";
import get from "@beeldit/core/services/get";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import update from "@beeldit/core/services/update";

function useInitialize() {
  const { setElement, setShowModal, setSelectedLang, setBackendFormErrors } =
    useContext(CreateActionContext);
  const errorHandler = useErrorHandler();
  return (formDefaultValues: any) => {
    get("combinations/calculate-percentages", formDefaultValues.product_id)
      .then((response: any) => {
        const element = {
          ...formDefaultValues,
          ...{
            commission_percentage: response.data.commission_percentage,
            shipment_percentage: response.data.shipment_percentage,
            commission: 0,
            shipping: 0,
            commerce_price: 0,
            calculated_commerce_price: 0,
            tax: 0,
          },
        };
        setBackendFormErrors({});
        setElement(element);
        setSelectedLang("es");
        setShowModal(true);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useInitialize;
